import React, {
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

import ChatChannelListContext from '../../../context/ChatChannelListContext';

import {
  Container,
  StyledSortButton,
  StyledSortIcon,
} from './styles';
import texts from './texts.json';

const ChannelSort = ({ isCustomSortEnabled }) => {
  const {
    isRecentFirst,
    setIsRecentFirst,
  } = useContext(ChatChannelListContext);

  return (
    <Container>
      <Tooltip
        title={isCustomSortEnabled ? texts.sortDisabledHint : ''}
        placement="bottom-start"
        arrow
      >
        <span>
          <StyledSortButton onClick={() => setIsRecentFirst((prev) => !prev)} disabled={isCustomSortEnabled}>
            <StyledSortIcon $isRecentFirst={isRecentFirst} />
            {isRecentFirst ? texts.sortByOldestFirst : texts.sortByRecentFirst}
          </StyledSortButton>
        </span>
      </Tooltip>
    </Container>
  );
};

ChannelSort.propTypes = {
  isCustomSortEnabled: PropTypes.bool,
};

ChannelSort.defaultProps = {
  isCustomSortEnabled: false,
};

export default ChannelSort;
